import axios from 'axios'
import { trackQuoteResultsViewed } from 'helpers/analytics'
import { clean } from './utility/jsonFunctions'
import { getUserToken } from './utility/localStorageFunctions'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/quotes-api/quotes`

async function createQuote(
  quote: any,
  onProgress?: (percent: number, event: ProgressEvent) => void,
) {
  const token = await getUserToken('quotes')
  var cleanQuote = {
    ...quote,
  }
  clean(cleanQuote)

  const response = await axios({
    method: 'post',
    url: BASE_URL.concat(`/taxi`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...cleanQuote,
      },
    },
    onDownloadProgress: (e) => {
      const total = e.total ?? 0
      if (total > 0) {
        const percent = Math.round((e.loaded * 100) / total)
        if (onProgress) onProgress(percent, e as unknown as ProgressEvent)
      }
    },
  })
  console.log('createQuote', response)
  trackQuoteResultsViewed(response.data, quote)
  return response
}

async function createReallocationQuote(
  id: string,
  onProgress?: (percent: number, event: ProgressEvent) => void,
) {
  const token = await getUserToken('quotes')

  const response = await axios({
    method: 'GET',
    url: BASE_URL.concat(`/retrieveForReallocation/${id}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    onDownloadProgress: (e) => {
      const total = e.total ?? 0
      if (total > 0) {
        const percent = Math.round((e.loaded * 100) / total)
        if (onProgress) onProgress(percent, e as unknown as ProgressEvent)
      }
    },
  })
  return response
}

export const quotesAPI = {
  createQuote,
  createReallocationQuote,
}
